import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './StudentInfoScreen';
import StudentInfo from './StudentInfoScreen';
import { StoreState } from 'src/store/reducers';
import { getStudent, getFiles, getIntakes } from 'src/store/actions/student-actions';
import { QueryParams } from '../../../../../../types/grid';
import { getProgramBooks } from 'src/store/actions/program-book-actions';

function mapStateToProps(state: StoreState): StateProps {
    return {
        student: state.students.current,
        files: state.students.currentFiles,
        programBooks: state.programBooks,
        intakes: state.students.currentIntakes,
    };
}

function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
    return {
        getProgramBooks: (params: QueryParams) => dispatch(getProgramBooks(params)),
        getData: (id) => dispatch(getStudent(id)),
        getFiles: (id) => dispatch(getFiles(id)),
        getIntakes: (id) => dispatch(getIntakes(id)),
    };
}

const StudentInfoScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(StudentInfo);

export default StudentInfoScreen;
